import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { clearSnackbar } from '../redux/actions/snackbarActions';

export const SUCCESS = 'success';
export const ERROR = 'error';
export const WARNING = 'warning';
export const INFO = 'info';

export default function SuccessSnackbar() {
  const dispatch = useDispatch();

  const { snackbarMessage, snackbarSeverity, snackbarOpen } = useSelector(
    (state) => state.ui,
  );

  function handleClose() {
    dispatch(clearSnackbar());
  }

  return (
    <Snackbar
      autoHideDuration={4000}
      onClose={handleClose}
      open={snackbarOpen}
    >
      <Alert severity={snackbarSeverity}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
